import { createAction } from '@reduxjs/toolkit'

import {
  IMetric,
  IMetricConfig,
  IMetricRawData,
  TDefinitionSlice,
  THeadlineMetric,
  TMetricDataPostBody
} from 'types/GlobalMetric'

// tryGetAllMetrics
export const getAll = createAction('get_all_metrics')
export const getAllSuccess = createAction<IMetric[]>('get_all_metrics_success')
export const getAllFailed = createAction('get_all_metrics_failed')

// tryGetHeadlineMetric
export const getHeadline = createAction('get_headline_metric')
export const getHeadlineSuccess = createAction<THeadlineMetric>(
  'get_headline_metric_success'
)
export const getHeadlineFailed = createAction('get_headline_metric_failed')

// tryUpdateMetric
export const update = createAction('update_metric')
export const updateSuccess = createAction<IMetric>('update_metric_success')
export const updateFailed = createAction('update_metric_failed')

// tryPutConfigValue
export const putConfig = createAction('put_metric_config')
export const putConfigSuccess = createAction<IMetricConfig>(
  'put_metric_config_success'
)
export const putConfigFailed = createAction('put_metric_config_failed')

// tryCreateCustomMetric
export const createSuccess = createAction<IMetric>('create_metric_success')

// tryDeleteCustomMetric
export const deleteSuccess = createAction<string>('delete_metric_success')

// tryFetchMetricData
export const getOneRaw = createAction<{
  id: string
  body: TMetricDataPostBody
}>('get_one_metric_raw')
export const getOneRawSuccess = createAction<{
  data: IMetricRawData
  id: string
  body: TMetricDataPostBody
}>('get_one_metric_raw_success')
export const getOneRawFailed = createAction<{
  id: string
  body: TMetricDataPostBody
  missingSlices: TDefinitionSlice[]
}>('get_one_metric_raw_failed')
